import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Loading from 'uI/Loading/Loading';
import BreadCrumb from 'uI/BreadCrumb/BreadCrumb';
import TopSection from 'components/UDCProduct/TopSection/TopSection';
import SpecificSection from 'components/UDCProduct/SpecificSection/SpecificSection';
import BottomSection from 'components/UDCProduct/BottomSection/BottomSection';

import { degrees, postgraduates } from 'constants/udcProducts';

import classes from './UDCProduct.module.css';

const UDCProduct = () => {
  const [loading, setLoading] = useState(true);
  const { productType, idProduct } = useParams();
  const [productData, setProductData] = useState({});

  useEffect(() => {
    if (productType === 'degree') {
      Object.entries(degrees).map(item => {
        if (idProduct === item[0]) {
          setProductData(item[1]);
        }
      });
    } else {
      Object.entries(postgraduates).map(item => {
        if (idProduct === item[0]) {
          setProductData(item[1]);
        }
      });
    }
    setLoading(false);
  }, []);

  return (
    <>
      {!loading ? (
        <>
          <BreadCrumb
            productType={productType}
            productName={productData.title}
          />
          <div className={classes.productContainer}>
            <SpecificSection productData={productData} />
            <TopSection productData={productData} />
            <BottomSection productData={productData} />
          </div>
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default UDCProduct;
